module.exports = __webpack_public_path__ + "icon-white-copy___3eDYD.svg";